__turbopack_context__.v({
  "answer": "Question-module-scss-module__thK6Sa__answer",
  "arrow": "Question-module-scss-module__thK6Sa__arrow",
  "container": "Question-module-scss-module__thK6Sa__container",
  "questionTitle": "Question-module-scss-module__thK6Sa__questionTitle",
  "rotate": "Question-module-scss-module__thK6Sa__rotate",
  "title": "Question-module-scss-module__thK6Sa__title",
});
